import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';


const ReportsSidebar = ( { setReportType } ) => {

    return (
        <Col className='pe-0' md={2} style={ { height: '100%' } }>
            <Row className='tf-section-container me-2' style={ { height: 'calc(100% - 15px)' } }>
                <Col className='p-0'>
                    <ListGroup variant='flush'>
                        <ListGroup.Item>
                            <span className='tf-reporting-sidebar-title'>On the Business</span>
                            <ListGroup variant='flush'>
                                <ListGroup.Item className='border-0'>
                                    <Link to='#' onClick={ () => setReportType( 'sources' ) } style={ { textDecoration: 'none' } }>Source Breakdown</Link>
                                </ListGroup.Item>
                                <ListGroup.Item className='border-0'>
                                    <Link to='#' onClick={ () => setReportType( 'conversions' ) } style={ { textDecoration: 'none' } }>Conversions</Link>
                                </ListGroup.Item>
                                <ListGroup.Item className='border-0'>
                                    Leaderboards
                                    <ListGroup>
                                        <ListGroup.Item className='border-0'>
                                            <Link to='#' onClick={ () => setReportType( 'lbindividual' ) } style={ { textDecoration: 'none' } }>Individuals</Link>
                                        </ListGroup.Item>
                                        <ListGroup.Item className='border-0'>
                                            <Link to='#' onClick={ () => setReportType( 'lbteam' ) } style={ { textDecoration: 'none' } }>Teams</Link>
                                        </ListGroup.Item>
                                        <ListGroup.Item className='border-0'>
                                            <Link to='#' onClick={ () => setReportType( 'lbcompany' ) } style={ { textDecoration: 'none' } }>Companies</Link>
                                        </ListGroup.Item>
                                    </ListGroup>
                                </ListGroup.Item>
                            </ListGroup>
                        </ListGroup.Item>
                    </ListGroup>
                    <ListGroup variant='flush'>
                        <ListGroup.Item className='border-0'>
                            <span className='tf-reporting-sidebar-title'>In the Business</span>
                            <ListGroup variant='flush'>
                                <ListGroup.Item className='border-0'>
                                    <Link to='#' onClick={ () => setReportType( 'gt' ) } style={ { textDecoration: 'none' } }>Greatness Tracker</Link>
                                </ListGroup.Item>
                                <ListGroup.Item className='border-0'>
                                    <Link to='#' onClick={ () => setReportType( 'lt' ) } style={ { textDecoration: 'none' } }>Lead Tracker</Link>
                                </ListGroup.Item>
                                <ListGroup.Item className='border-0'>
                                    Whale Hunting
                                </ListGroup.Item>
                                <ListGroup.Item className='border-0'>
                                    <Link to='#' onClick={ () => setReportType( 'bday' ) } style={ { textDecoration: 'none' } }>Birthday Tracker</Link>
                                </ListGroup.Item>
                                <ListGroup.Item className='border-0'>
                                    <Link to='#' onClick={ () => setReportType( 'amr' ) } style={ { textDecoration: 'none' } }>AMR Tracker</Link>
                                </ListGroup.Item>
                                {/* <ListGroup.Item className='border-0'>
                                    <Link to='#' onClick={ () => setReportType( 'funnel' ) } style={ { textDecoration: 'none' } }>Funnel</Link>
                                </ListGroup.Item> */}
                            </ListGroup>
                        </ListGroup.Item>
                    </ListGroup>
                </Col>
            </Row>
        </Col>
    )
}

const mapProps = ( state ) =>( {
    // aid: state.user.aid,
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( ReportsSidebar );